export default "<h1><i>Wel-Come</i></h1>\r\n"